var render = function render(_c,_vm){return _c('div',{staticClass:"v-loader"},_vm._l((4),function(item){return _c('div',{staticClass:"v-loader__icon"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }